export const globalErrorMessage = [
    {
    fields: {
        code: 'MISSING_FULL_NAME',
        message: 'Please enter full name.'
    },
    sys: {
        id: '3m5lCUAMwNfCsridLt0mUw',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'MISSING_ORGANIZATION',
        message: 'Please enter your organization.'
    },
    sys: {
        id: 'mRixT6HYtdwBZAbOtWk7F',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'ACCOUNT_LOCKED',
        message: 'Your account is locked. Please reset your password or contact Moderna CARE Team.'
    },
    sys: {
        id: '115ZP8OYlwGNDKJwDNgKKv',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'EMAIL_MISMATCH',
        message: 'Please enter matching email'
    },
    sys: {
        id: '6jD9yqqDbOTWXbIPnSlV1t',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'INVALID_PHONE_FORMAT',
        message: 'Please enter a valid phone number.'
    },
    sys: {
        id: '5Sf11EYKetippY4rxdx9RX',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'GENERAL_API_ERROR',
        message: 'An error occurred, the issue may be temporary. Please try again.'
    },
    sys: {
        id: '5MCO9Rh3KmE5EgYaTP4ki5',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'INVALID_CREDENTIALS',
        message: 'Incorrect Email or Password.'
    },
    sys: {
        id: '71Dx9dstC05i7e6vKvEtHa',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'MISSING_EMAIL',
        message: 'Please enter email'
    },
    sys: {
        id: '7wKCF1EB2k6KtTFp297w81',
        type: 'Entry'
    }
    },
    {
    fields: {
        code: 'INVALID_EMAIL_FORMAT',
        message: 'Please enter a valid email address.'
    },
    sys: {
        id: '52rznADjiuQg1pXmjcOm7',
        type: 'Entry'
    }
    }
]
